<div class="flex flex-column flex-middle m-t"
  [scrollNavTarget]="'Features' | translate">
  <div class="w-12 flex flex-justify-between-x flex-justify-between-l flex-wrap-m flex-wrap-s">
    @for (swatch of product.data.features_section | slice:0:6; track $index; let isLast = $last; let isFirst = $first) {
      <div class="w-2 w-4-m w-4-s flex flex-justify-center"
        [style.width]="(client.isX || client.isL) && '120px'"
        >
        <div class="w-12 ratio-1-1"
          style="max-width: 120px;">
          <img class="rf"
            [image]="swatch | optionImage : 'features_section'">
        </div>
      </div>
    }
  </div>
  <action class="button m-t"
  (click)=openModal()>{{'View all' | translate}}</action>
</div>
